import {WorkOrderStatus} from "../../Enums";

export default class GetSiteOrWarehouseWorkOrdersRequest {

    public constructionSiteOrWarehouseId: string = "";

    public workOrderStatuses: WorkOrderStatus[] = [];
}